import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map'; // add map function to observable
import 'rxjs/add/operator/catch';

import { environment } from '../../environments/environment';
import { AuthenticationService, TokensService } from '.';
import { Util } from '../shared/util/util'

@Injectable()
export class InventoryService {

    private fulfillmentURL = environment.fulfillmentURL + 'articles/';
    private fulfillmentShelfURL = environment.fulfillmentURL + 'shelves/';

    constructor(
        private http: Http,
        private authenticationService: AuthenticationService) {
    }

    getArticlesOnShelf(shelf: string) {
        return this.http.get(this.fulfillmentShelfURL + shelf + '/' + this.authenticationService.getStorageName() + '/articles', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let orders = res.json();
                return orders;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load articles for shelf"));
            });
    }

    getArticles() {
        return this.http.get(this.fulfillmentURL, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let orders = res.json();
                return orders;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load articles"));
            });
    }

    deleteArticle(reference: string) {
        return this.http.delete(this.fulfillmentURL + reference, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not delete article with ref " + reference));
            });
    }

    getShelves(reference: string) {
        return this.http.get(this.fulfillmentURL + reference + '/shelves', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let items = res.json();
                return items;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not get shelves of article with ref " + reference));
            });
    }

    getAllShelves() {
        return this.http.get(this.fulfillmentShelfURL, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not get shelves"));
            });
    }

    deleteShelf(reference: string, shelf: string) {
        return this.http.delete(this.fulfillmentURL + reference + '/shelves/' + shelf + '/' +  this.authenticationService.getStorageName(), {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not delete shelf of article with ref " + reference));
            });
    }

    changeItems(reference: string, items: number, remark: string, shelf: string, newshelf: string) {
        let request: any = {};
        request.remark = remark;
        request.items = items
        request.shelf = shelf;
        request.newShelf = newshelf;
        request.storage = this.authenticationService.getStorageName();
        return this.http.post(this.fulfillmentURL + reference, request, {
            headers: this.authenticationService.getHeader()
        })
            .catch((error: any) => {
                return Util.handleErrorMessage(error);
            });
    }

    getArticle(reference: string) {
        return this.http.get(this.fulfillmentURL + reference, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let article = res.json();
                return article;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load article with ref " + reference));
            });
    }

    getArticleByBarcode(barcode: string) {
        return this.http.get(this.fulfillmentURL + "barcode/" + barcode, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let article = res.json();
                return article;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load article with barcode " + barcode));
            });
    }

    cuArticle(element: any) {
        return this.http.post(this.fulfillmentURL, element, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not store article"));
            });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/services/inventory.service.ts